import { createContext } from 'react';
const PickersContext = /*#__PURE__*/createContext({});
export default PickersContext;